import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Pack\GetPackActivitiesByIdController::__invoke
* @see app/Http/Controllers/Pack/GetPackActivitiesByIdController.php
* @route '/api/pack/{pack}/activities'
*/
const GetPackActivitiesByIdController = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPackActivitiesByIdController.url(args, options),
    method: 'get',
})

GetPackActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/pack/{pack}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Pack\GetPackActivitiesByIdController::__invoke
* @see app/Http/Controllers/Pack/GetPackActivitiesByIdController.php
* @route '/api/pack/{pack}/activities'
*/
GetPackActivitiesByIdController.url = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { pack: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { pack: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            pack: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        pack: typeof args.pack === 'object'
        ? args.pack.id
        : args.pack,
    }

    return GetPackActivitiesByIdController.definition.url
            .replace('{pack}', parsedArgs.pack.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Pack\GetPackActivitiesByIdController::__invoke
* @see app/Http/Controllers/Pack/GetPackActivitiesByIdController.php
* @route '/api/pack/{pack}/activities'
*/
GetPackActivitiesByIdController.get = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPackActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Pack\GetPackActivitiesByIdController::__invoke
* @see app/Http/Controllers/Pack/GetPackActivitiesByIdController.php
* @route '/api/pack/{pack}/activities'
*/
GetPackActivitiesByIdController.head = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPackActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetPackActivitiesByIdController